import { defineMessages } from '@jutro/locale';

export default defineMessages({
    continue: {
        id: 'ml.gateway.views.account-detail.Continue',
        defaultMessage: 'CONTINUE'
    },
    onetimePaymentDocument: {
        id: 'ml.gateway.views.account-detail.your one-time payment document',
        defaultMessage: 'your one-time payment document'
    },
    wellReviewDocumentNext: {
        id: 'ml.gateway.views.account-detail.Well review your one-time payment document next',
        defaultMessage: 'We\'ll review {onetimePaymentDocument} next'
    },
    title: {
        id: 'ml.gateway.views.account-detail.Forms',
        defaultMessage: 'Forms'
    },
    subtitle: {
        id: 'ml.gateway.views.account-detail.Signature Type must be selected for each form',
        defaultMessage: 'Signature Type must be selected for each form'
    },
    colForm: {
        id: 'ml.gateway.views.account-detail.Form',
        defaultMessage: 'FORM'
    },
    colType: {
        id: 'ml.gateway.views.account-detail.Signature Type',
        defaultMessage: 'SIGNATURE TYPE'
    },
    colActions: {
        id: 'ml.gateway.views.account-detail.Actions',
        defaultMessage: 'ACTIONS'
    },
    availableForDownload: {
        id: 'ml.gateway.views.account-detail.This form will be available for download on next screen.',
        defaultMessage: 'This form will be available for download on next screen.'
    },
    sendToMailingAddress: {
        id: 'ml.gateway.views.account-detail.This form will be sent to your mailing address.',
        defaultMessage: 'This form will be sent to your mailing address.'
    },
    enterValidEmail: {
        id: 'ml.gateway.views.account-detail.Enter a valid email address',
        defaultMessage: 'Enter a valid email address'
    },
    formDescription: {
        id: 'ml.gateway.views.account-detail.Customer Authorization Agreement for One-Time Direct Payments',
        defaultMessage: 'Customer Authorization Agreement for One-Time Direct Payments'
    },
    faxNumberLabel: {
        id: 'ml.gateway.views.account-detail.Fax Number',
        defaultMessage: 'Fax Number'
    },
    faxNumberValidationMessage: {
        id: 'ml.gateway.views.account-detail.Enter a 10 digit phone number without dashes',
        defaultMessage: 'Enter a 10 digit fax number without dashes'
    },
    faxNumberInvalid: {
        id: 'ml.gateway.views.account-detail.Invalid fax number',
        defaultMessage: 'Invalid fax number'
    },
    requiredField: {
        id: 'ml.gateway.views.account-detail.This is a required field',
        defaultMessage: 'This is a required field'
    },
    emailLabel: {
        id: 'ml.gateway.views.account-detail.Primary insured email',
        defaultMessage: 'Primary insured email'
    },
    emailPlaceholder: {
        id: 'ml.gateway.views.account-detail.Enter x email',
        defaultMessage: 'Enter {contactName} email'
    },
    emailValidationMessage: {
        id: 'ml.gateway.views.account-detail.Enter a valid email address',
        defaultMessage: 'Enter a valid email address'
    }
});